import { Routes, Route } from 'react-router-dom';
import { Overview } from './patient-info/Overview';
import { NewPatients } from './patient-info/NewPatients';
import { Insurance } from './patient-info/Insurance';
import { Portal } from './patient-info/Portal';

export function PatientInfo() {
  return (
    <Routes>
      <Route index element={<Overview />} />
      <Route path="new-patients" element={<NewPatients />} />
      <Route path="insurance" element={<Insurance />} />
      <Route path="portal" element={<Portal />} />
    </Routes>
  );
}